module.exports = __webpack_public_path__ + "static/media/BacktrackRegular.52bae912.ttf";